export const orderPreferencesFormFields = {
  accommodation: "accommodation",
  details: "details",
  hotelName: "hotelName",
  instruction: "instruction",
  reservationDetails: "reservationDetails",
  unitNumber: "unitNumber",
};
